module.exports = __webpack_public_path__ + "static/media/disease-health-wellness.a75cdb83.png";